import { useEffect, useState } from 'react';
import { URI } from '../../../constants';

/**
 * Грузит список городов СДЭК (REST, не GraphQL) для автокомплита выбора города ПВЗ.
 * Ответ бэка: [{ name, id }], где id — CDEK city_code. Маппим в опции react-select.
 * Список кешируется на бэке (24ч), грузим один раз за сессию.
 */
export const useSdekCities = () => {
  const [cities, setCities] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;

    fetch(`${URI}/api/sdek-service-city-list?country=Россия`)
      .then((res) => res.json())
      .then((data) => {
        if (cancelled || !Array.isArray(data)) return;
        setCities(data.map((c) => ({ value: c.id, label: c.name })));
      })
      .catch(() => {})
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, []);

  return { cities, loading };
};
